/* eslint-disable no-restricted-globals */
// eslint-disable-next-line no-var
export var ampIntegrationContext: typeof globalThis;
